export default __webpack_public_path__ + "static/media/IsiahBio.a2bfd7f8.jpg";